<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="378px" close-on-click-modal :show-close="true">
    <template #title>
      <h1 class="title">{{ config.title }}</h1>
      <i class="el-icon-circle-close" @click="dialogVisible = false" />
    </template>
    <template #default>
      <p class="content">
        监测到电脑安装的浏览器版本过低，可能无法提供安全稳定的访问环境，您的电脑可能受到病毒、间谍软件和其他恶意软件的攻击，它们可以窃取或损害您的业务数据和信息。坚持使用当前浏览器，您将看到排版错误、功能不全、无法正常使用甚至是满屏乱码。
        <span class="important">{{ config.content }}</span>
      </p>
    </template>
    <template #footer>
      <div class="footer">
        <a class="download" :href="config.downloadLink" target="_blank">
          <img :src="config.downloadImg" alt="" />
          {{ config.downloadText }}
        </a>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'explorerGuideModal',
  data() {
    return {
      dialogVisible: false,
      config: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const ua = navigator.userAgent;
      const [, version] = ua.match(/Chrome\/(\d+)/) || [, 0];
      if (version < 58) {
        this.dialogVisible = true;
        const config = {
          xp: {
            title: '推荐您使用360极速浏览器访问',
            content: '我们为您准备了最新的360极速浏览器安装包，推荐您下载并安装使用360极速浏览器来访问智云问诊平台',
            downloadLink: 'https://browser.360.cn/ee/',
            downloadText: '下载360极速浏览器',
            downloadImg: require('@/assets/img/icon_360.png')
          },
          unxp: {
            title: '推荐您使用Chrome浏览器访问',
            content: '我们为您准备了最新的Chrome浏览器的安装您，推荐您下载后安装使用最新版本Chrome访问智云问诊平台',
            downloadLink: 'https://www.google.cn/intl/zh-CN/chrome/',
            downloadText: '下载Chrome浏览器',
            downloadImg: require('@/assets/img/icon_chrome.png')
          }
        };
        this.config = ua.includes('Windows NT 5.1') ? config.xp : config.unxp;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$font-color: #242424;

.el-icon-circle-close {
  position: absolute;
  top: 12px;
  right: 12px;
  font-size: 16px;
  color: #bdbdbd;
  cursor: pointer;
}

.title {
  color: $font-color;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
/deep/.el-dialog__body {
  padding: 0 49px;
}
.content {
  color: $font-color;
  font-size: 14px;
  .important {
    font-weight: bold;
  }
}

.footer {
  display: flex;
  justify-content: center;

  .download {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 174px;
    height: 40px;
    font-size: 14px;
    color: $font-color;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    cursor: pointer;
    transition: all 0.15s;

    &:hover {
      color: #1e8dff;
      border: 1px solid #bdbdbd;
    }

    &:focus {
      color: #1e8dff;
      border: 1px solid #1e8dff;
    }

    img {
      margin-right: 13px;
      width: 20px;
      height: 20px;
    }
  }
}
</style>
